<template>
  <div>
    <div v-show="tutorial_id == 0">
      <b-row class="col-12">
      <b-input-group small class="col-3 mt-3 mb-3">
        <b-button @click.prevent.stop="addtutorial" variant="primary" class="gdq_faded"><span class="icon-plus mr-2"></span>Add tutorial</b-button>
      </b-input-group>

      <b-input-group small class="col-3 mt-3 mb-3">
        <b-form-input
          v-model="search"
          placeholder="Search heading"
          type="text"
          @input="tutorials_filter"
          autocomplete="off"
        >
        </b-form-input>
        <b-input-group-text slot="append">
          <b-btn
            variant="link"
            size="sm"
            @click="search = ''"
            class="p-0 i"
          >
          X
          </b-btn>
        </b-input-group-text>
      </b-input-group>
      </b-row>
      <b-table 
        id="tutorials"
        hover 
        :items="tutorials" 
        :fields="fields"
        :busy="loading"
        :sort-by="orderby"
        :sort-desc="orderdesc"
        @sort-changed="tutorials_sort"
        :no-local-sorting="true"
        ref="tutorials"
        @row-clicked="edittutorial"
      >
        <template v-slot:head(select)="data">
          <b-form-checkbox
          @click.native.stop
            @change="selectall(selected)"
            v-model="selected"
          >
            <span class="text-muted" v-if="selectcount>0">({{selectcount}})</span>
          </b-form-checkbox>
        </template>
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner variant="primary" class="align-middle"></b-spinner>
          </div>
        </template>
        <template v-slot:cell(select)="data">
        <div class="py-1">
            <b-form-checkbox
              :id="'selected'+data.index"
              v-model="data.item.selected"
              @change="countselected"
            >
            </b-form-checkbox>
          </div>
        </template>
        <template v-slot:cell(tutorial_heading)="data">
          <div class="py-1">
            {{ data.item.tutorial_heading }}
          </div>
        </template>
        <template v-slot:cell(empty)="data">
          <span 
            @click.prevent.stop="deletetutorial(data.item.id)"
          >
            <fa-icon name="trash-alt" />
          </span>
        </template>
      </b-table>
      <b-row class="col-12 justify-content-center">
        <b-pagination
          v-if="rows > perPage"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="tutorials"
          @input="tutorials_get"
        >
        </b-pagination>
      </b-row>
    </div>
    <div v-show="tutorial_id != 0">
      <Tutorial />
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import Tutorial from './Tutorial';

const fields = [
  { key: 'select', label: '', sortable: false, thClass: 'col gdq-w-10', tdClass: 'col gdq-w-10' },
  { key: 'tutorial_heading', label: 'Heading', sortable: true, thClass: 'col', tdClass: 'col' },
  { key: 'empty', label: '', sortable: false, thClass: 'col gdq-w-10', tdClass: 'col gdq-w-10' },
];
export default {
  components: {
    Tutorial,
  },
  name: 'Tutorials',
  mounted() {
    this.tutorials_get()
  },
  data: function() {
    return {
      search: '',
      searching: false,
      searchcalc: false,
      fields: fields,
      tutorials: [],
      allowmultiselect: false,
      muteclass: 'text-muted',
      currentPage: 1,
      perPage: 10,
      rows: 0,
      loading: null,
      orderby: 'tutorial_heading',
      orderdesc: false,
      selected: 0,
      bulkaction: 0,
      selectcount: 0,
    }
  },
  computed: {
    tutorial_id: {
      get() {
        return this.$store.state.currenttutorial_id;
      }
    },
    tutorialchanged: {
      get() {
        return this.$store.state.tutorialchanged;
      }
    },
  },
  watch: {
    search: function() {
      this.searching = true
      this.tutorials_filter()
    },
    tutorialchanged: function() {
      if (this.$store.state.tutorialchanged != 0) {
        this.tutorial_get(this.$store.state.tutorialchanged);
        this.$store.dispatch('tutorialchanged_set',{ tutorial_id: 0 });
      }
    },
    tutorial_id: function() {
      this.tutorials_get();
    },
  },
  methods: {
    deletetutorial(id) {
      this.$store.dispatch('tutorial_delete', { tutorial_id: id })
      .then(() => {
        this.tutorials_get();
      });
    },
    addtutorial() {
      this.$store.dispatch('tutorial_setcurrent',{ tutorial_id: -1 })
      .then(() => {
        this.tutorials_get();
      });
    },
    edittutorial(item) {
      this.$store.dispatch('tutorial_setcurrent',{ tutorial_id: item.id })
      .then(() => {
        this.tutorials_get();
      });
    },
    tutorial_get(tutorial_id) {
      var tutorial_heading = '';
      this.$store.dispatch('tutorial_fetch', { tutorial_id: tutorial_id })
      .then((resp) => {
        tutorial_heading = resp.data.tutorial_heading;
        for (var i=0; i<this.tutorials.length; i++) {
          if (this.tutorials[i].id == tutorial_id) {
            this.tutorials[i].tutorial_heading = tutorial_heading;
          }
        }
      });
    },
    selectall(selected) {
      var setselectto = !selected;
      for (var i=0;i<this.tutorials.length; i++) {
        this.tutorials[i].selected = setselectto;
      }
      this.countselected();
    },
    countselected() {
      this.$nextTick(() => {
        var selectcount = 0;
        for (var i=0;i<this.tutorials.length; i++) {
          if (this.tutorials[i].selected) {
            selectcount++;
          }
        }
        this.selectcount = selectcount;
      })
    },
    tutorials_filter: _.debounce(function() {
      this.searchcalc = true
      setTimeout(function() {
        this.tutorials_get();
        this.searchcalc = false;
        this.searching = false;
      }.bind(this),500)
    },300),
    tutorials_sort(context) {
      this.orderby = context.sortBy;
      this.orderdesc = context.sortDesc;
      this.tutorials_get();
    },
    tutorials_get() {
      this.loading = true;
      var filter = '';
      if (this.search != '') {
        filter = {
          tutorial_heading: {
            operator: 'LIKE',
            value: '%'+this.search+'%',
          },
        }
      } else {
        filter = {
          id: {
            operator: ' > ',
            value: 0,
          }
        }
      }
      this.$store.dispatch('tutorials_fetch', {
        start: (this.currentPage - 1)*this.perPage,
        limit: this.perPage,
        orderby: this.orderby,
        order: (this.orderdesc==false)?'ASC':'DESC',
        filter: filter,
        usergroup_id: this.filterusergroup,
      })
      .then((resp) => {
         this.tutorials = [];
         for (var i=0;i<resp.data.result.length;i++) {
           var result = {
             id: resp.data.result[i].id,
             selected: false,
             tutorial_heading: resp.data.result[i].tutorial_heading,
           }
           this.tutorials.push(result);
         }
         this.rows = resp.data.total;
         this.loading = false;
      });
    },
  },
}
</script>
<style>
.gdq-faded {
  opacity: 0.5;
}
</style>
